module.exports = __webpack_public_path__ + "static/media/1.ddc49438.png";